import { USER_ROLE } from '@constants';

export const withRole = (role, data) => ({ ...data, role });
withRole[USER_ROLE.ADMIN] = (data) => withRole(USER_ROLE.ADMIN, data);
withRole[USER_ROLE.SUPPORT] = (data) => withRole(USER_ROLE.SUPPORT, data);
withRole[USER_ROLE.OWNER] = (data) => withRole(USER_ROLE.OWNER, data);
withRole[USER_ROLE.MANAGER] = (data) => withRole(USER_ROLE.MANAGER, data);
